// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1hZs-","filesListContainer":"PosDisputesFiles_filesListContainer__C4EaU","filesButton":"PosDisputesFiles_filesButton__3pLkj"};